<template>
  <div class="br-confirm">
    <h2 class="br-confirm__title">{{ $t('lbl_EMPBE_BR_Confirm_Title') }}</h2>

    <div class="br-confirm__preview-block">
      <!-- Figma 988:17698 / Hover 2532:71433：右上角 Re-upload；悬停蒙层 + 中间放大镜 -->
      <div
        class="br-confirm__preview"
        :class="{
          'br-confirm__preview--error': scanBlockerKeys.length > 0,
          'br-confirm__preview--hovered': isPreviewHovered,
        }"
        @mouseenter="isPreviewHovered = true"
        @mouseleave="isPreviewHovered = false"
      >
        <button
          type="button"
          class="br-confirm__preview-hit"
          :aria-label="$t('lbl_EMPBE_BR_DocumentPreview')"
          @click="$emit('preview')"
        >
          <img
            v-if="previewUrl && !isPdf"
            :src="previewUrl"
            :alt="fileName"
            class="br-confirm__preview-img"
          />
          <div
            v-else-if="previewUrl && isPdf"
            class="br-confirm__preview-pdf"
            aria-hidden="true"
          >
            <i class="fa fa-file-pdf-o br-confirm__preview-pdf-icon" />
            <span class="br-confirm__preview-pdf-name">{{ pdfDisplayName }}</span>
          </div>
          <div v-else class="br-confirm__preview-placeholder" />
          <span class="br-confirm__preview-overlay" aria-hidden="true">
            <feather type="zoom-in" :size="32" class="br-confirm__preview-zoom" />
          </span>
        </button>
        <button
          type="button"
          class="br-confirm__reupload"
          @click.stop="onReuploadClick"
        >
          {{ $t('lbl_EMPBE_BR_Preview_Reupload') }}
        </button>
      </div>
      <BrScanAlert :alert-keys="scanAlertKeys" />
    </div>
    <p class="br-confirm__expiry-helper">{{ $t('lbl_EMPBE_BR_Confirm_AccuracyHint') }}</p>

    <BrConfirmSubmitForm
      :value="localForm"
      :submitting="submitting"
      :scan-blocker-keys="scanBlockerKeys"
      :scan-reset-token="scanResetToken"
      @input="onFormInput"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import BrScanAlert from './BrScanAlert.vue';
import BrConfirmSubmitForm from './BrConfirmSubmitForm.vue';
import {
  canSubmitBrConfirmForm,
  createEmptyBrConfirmForm,
} from '../utils/brConfirmSubmit';

export default {
  name: 'BrConfirmSubmit',
  components: {
    BrScanAlert,
    BrConfirmSubmitForm,
  },
  props: {
    previewUrl: { type: String, default: '' },
    fileName: { type: String, default: '' },
    /** PDF 确认页不走 img 预览 */
    isPdf: { type: Boolean, default: false },
    form: { type: Object, default: () => ({}) },
    displayNameEn: { type: String, default: '' },
    displayNameZh: { type: String, default: '' },
    submitting: { type: Boolean, default: false },
    scanAlertKeys: { type: Array, default: () => [] },
    scanBlockerKeys: { type: Array, default: () => [] },
    /** 每次重新扫描递增，清空表单触碰态 */
    scanResetToken: { type: [Number, String], default: 0 },
  },
  data() {
    return {
      localForm: createEmptyBrConfirmForm(),
      /** 不用纯 CSS :hover：选文件对话框关闭后浏览器会卡住 hover */
      isPreviewHovered: false,
    };
  },
  computed: {
    pdfDisplayName() {
      const name = String(this.fileName || '').trim();
      return name || 'PDF';
    },
  },
  watch: {
    previewUrl() {
      this.clearPreviewHover();
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.syncLocalForm(value);
      },
    },
    displayNameEn() {
      this.syncDisplayNames();
    },
    displayNameZh() {
      this.syncDisplayNames();
    },
  },
  methods: {
    clearPreviewHover() {
      this.isPreviewHovered = false;
      if (typeof document !== 'undefined' && document.activeElement) {
        const el = document.activeElement;
        if (el && typeof el.blur === 'function') {
          el.blur();
        }
      }
    },
    onReuploadClick() {
      this.clearPreviewHover();
      this.$emit('reupload');
    },
    syncDisplayNames() {
      this.localForm.displayNameEn = String(this.displayNameEn || '').trim();
      this.localForm.displayNameZh = String(this.displayNameZh || '').trim();
    },
    syncLocalForm(value = {}) {
      this.localForm = {
        ...this.localForm,
        registeredCompanyName: value.registeredCompanyName || '',
        registrationNo: value.registrationNo || '',
        hasExpirationDate: value.hasExpirationDate === true,
        startDate: value.startDate || '',
        expirationDate: value.expirationDate || '',
        displayNameEn: String(this.displayNameEn || '').trim(),
        displayNameZh: String(this.displayNameZh || '').trim(),
      };
    },
    onFormInput(next) {
      const wasHasExpiry = this.localForm.hasExpirationDate === true;
      const willHasExpiry = next.hasExpirationDate === true;
      if (wasHasExpiry !== willHasExpiry) {
        // 切换 Yes/No：保留已有起迄，绝不默认写成今天（Macy：有值用原值；缺的保持空）
        this.localForm = {
          ...next,
          startDate: String(next.startDate || this.localForm.startDate || '').trim(),
          expirationDate: String(next.expirationDate || this.localForm.expirationDate || '').trim(),
        };
        return;
      }
      this.localForm = next;
    },
    onSubmit() {
      if (this.submitting || !canSubmitBrConfirmForm(this.localForm, this.scanBlockerKeys)) {
        return;
      }
      this.$emit('submit', {
        ...this.localForm,
        displayNameEn: (this.localForm.displayNameEn || '').trim(),
        displayNameZh: (this.localForm.displayNameZh || '').trim(),
      });
    },
  },
};
</script>
